import React, { useContext } from "react";
import Box from "@mui/material/Box";

import AppContext from "../appContext";
import CalendarButton from "./CalendarButton";
import Create from "./Create";
import Alias from "./Alias";

export default function Client() {
  const {
    app: {
      client: { writeAccess },
    },
  } = useContext(AppContext);
  return (
    <Box display="flex" justifyContent="space-between">
      <Alias />
      <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
        {writeAccess ? <CalendarButton /> : null}
        <Create />
      </Box>
    </Box>
  );
}
